import React from "react";

const NotFound = () => (
  <div className="not-found">
    <div className="center">
      <h1>
        404 <small>Page not found!</small>
      </h1>
      <h2>Stay Tuned we will be right back to you!</h2>
      <a href="https://dwellworksliving.com/" rel="noopener noreferrer">
        Visit Dwellworks Living
      </a>
    </div>
  </div>
);

export default NotFound;
